import React, { Component } from 'react'
import { func } from 'prop-types'
import { view } from '@risingstack/react-easy-state'
import { translate } from 'react-i18next'
import { stores } from '../../stores'
import { Input } from '../ui/inputs/Input'
import { PhoneInput } from '../ui/inputs/PhoneInput'
import { validation } from './validation'
import { GardenersBulletList } from '../gardeners/GardenersBulletList'
import { NavigationButtons } from '../ui/buttons/NavigationButtons'
import { CouponCodeInput } from '../ui/inputs/CouponCodeInput'
import { pushGtmTrigger } from '../../utilities/window'
import { InquiryPathVersions } from '../../stores/inquiry'

class InformationsStepComponent extends Component {
  componentDidMount () {
    pushGtmTrigger(
      stores.inquiry.pathVersion === InquiryPathVersions.V1
        ? 'enter_address'
        : 'complete_information_v2'
    )
  }

  render () {
    let { t, next, previous } = this.props
    const update = (key) => (value) => {
      stores.inquiry[key] = value
    }

    return (<div className='demande__container'>
      <GardenersBulletList gardeners={stores.search.gardeners} selected={stores.inquiry.selected} />
      <form className='layout__container demande-form'>
        <h3 className='demande-form__h3'>{t('common:create:informations_title')}</h3>
        <div className='demande-form__container'>
          <Input value={stores.inquiry.lastName} onChange={update('lastName')} ref='lastName'
            label={t('common:fields:lastname')} bold name='lastName' type='text' rules={validation.lastName} />
          <Input value={stores.inquiry.firstName} onChange={update('firstName')} ref='firstName'
            label={t('common:fields:firstname')} bold name='firstName' type='text' rules={validation.firstName} />
          <PhoneInput value={stores.inquiry.phone} onChange={update('phone')} ref='phone'
            label={t('common:fields:phone')} bold name='phone' type='text' rules={validation.phone} />
          <Input value={stores.inquiry.email} onChange={update('email')} ref='email' label={t('common:fields:email')}
            bold name='email' type='text' rules={validation.email} />
          <Input value={stores.inquiry.invoicing.address}
            onChange={(value) => { stores.inquiry.invoicing.address = value }} ref='address'
            label={t('common:fields:adress')} bold name='address' type='text' rules={validation.address} />
          <div className='demande-form__city'>
            <div className='demande-form__half'>
              <Input value={stores.inquiry.invoicing.zipCode}
                onChange={(value) => { stores.inquiry.invoicing.zipCode = value }} ref='zipCode'
                label={t('common:fields:zip_code')} bold name='zipCode' type='text' rules={validation.zipcode} />
            </div>
            <div className='demande-form__half'>
              <Input value={stores.inquiry.invoicing.city}
                onChange={(value) => { stores.inquiry.invoicing.city = value }} ref='city'
                label={t('common:fields:city')} bold name='city' type='text' rules={validation.city} />
            </div>
          </div>
          {
            stores.account.hasCouponCode() ||
            <CouponCodeInput onChange={update('appliedCouponCodeId')} />
          }
        </div>
        <div className='form__submit' style={{ justifyContent: 'center' }}>
          {
            !stores.account.isActive()
              ? <div className='form__errormessage' style={{ textAlign: 'center', marginBottom: '10px' }}>
                <b>{t('common:account:blocked')}</b></div>
              : <NavigationButtons previous={() => previous()} next={() => next()} />
          }
        </div>
      </form>
    </div>)
  }
}

InformationsStepComponent.propTypes = {
  t: func,
  next: func,
  previous: func
}

export const InformationsStep = translate()(view(InformationsStepComponent))



// WEBPACK FOOTER //
// ./src/components/inquiry/InformationsStep.js